import { useCallback } from "react";
import { toast } from "sonner";

import { errorMessage } from "@/api/client";
import { useLogout } from "@/api/hooks/auth";

export const SIGNED_OUT_PATH = "/login?signedout=1";

/**
 * Signs out here, then of Hume ID (contract §13, row 5): the browser goes to Hume ID's sign-out, which comes back
 * to the sign-in page with `signedout=1` (no silent sign-in there). Failures are reported with a toast.
 */
export function useSignOut() {
  const { mutateAsync: logout } = useLogout();

  return useCallback(async () => {
    try {
      const { redirect } = await logout();
      window.location.assign(redirect || SIGNED_OUT_PATH);
    } catch (error) {
      toast.error("Couldn't sign out", { description: errorMessage(error) });
    }
  }, [logout]);
}
